module.exports = __webpack_public_path__ + "img/3H.108681c1.png";